import locationPinIcon from "assets/images/location-pin-small.svg";
import {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {newAppointment as strings} from "strings";

import Button from "components/Button";
import Divider from "components/Divider";
import MobileNavigationHeader from "components/MobileNavigationHeader";
import PageTitle from "components/PageTitle";
import Select from "components/Select";

import * as models from "liberty-core/api/models";
import {sortAppointmentTypes} from "liberty-core/sharedFunctions";

import {useCurrentPharmacy} from "lib/useCurrentPharmacy";

import styles from "./NewAppointmentPage.module.css";

type LocationState = {
  guestInfo?: models.AppointmentGuestInfo;
  selectedPatientId: string | null;
  apptCampaigns: models.AppointmentCampaign[];
  appointmentType?: string;
  insuranceInfo?: {frontImage: File; backImage: File};
};

export default function NewAppointmentPage() {
  const [pharmacy] = useCurrentPharmacy();
  const navigate = useNavigate();
  const location = useLocation();
  const locationState = location.state as LocationState;
  const guestInfo = locationState.guestInfo;
  const selectedPatientId = locationState.selectedPatientId;
  const apptCampaigns = locationState.apptCampaigns;
  const appointmentTypeParam = locationState.appointmentType;
  const insuranceInfo = locationState.insuranceInfo;

  // get list of unique appt types
  const selectableAppointmentTypes = apptCampaigns
    .map((c) => c.appointmentSettingType)
    .filter(
      (type, i) =>
        apptCampaigns.findIndex((c) => c.appointmentSettingType === type) === i,
    );

  const sortedAppointmentTypes = sortAppointmentTypes(
    selectableAppointmentTypes,
  );
  const [appointmentType, setAppointmentType] = useState(
    appointmentTypeParam ?? "",
  );

  useEffect(() => {
    if (!guestInfo && !selectedPatientId) {
      navigate("/appointments", {replace: true});
    }
  }, [navigate, guestInfo, selectedPatientId]);

  return (
    <div className={styles.container}>
      <MobileNavigationHeader
        onBack={() => {
          if (guestInfo) {
            navigate("/appointments/guest", {
              state: {
                apptCampaigns,
                guestInfo,
                insuranceInfo,
              },
            });
          } else {
            navigate("/appointments");
          }
        }}
        alwaysShown
      />
      <PageTitle className={styles.title}>{strings.title}</PageTitle>
      <div className={styles.location}>
        <img src={locationPinIcon} alt="" />
        <span className={styles.subtitle}>{pharmacy?.name}</span>
      </div>
      <Divider className={styles.divider} />
      <div className={styles.sectionLabel}>{strings.appointmentType}</div>
      <Select
        options={sortedAppointmentTypes.map((t) => ({label: t, value: t}))}
        value={appointmentType}
        onChange={(value: string) => {
          setAppointmentType(value);
        }}
        placeholder={strings.reason}
        className={styles.select}
      />
      <Button
        className={styles.proceed}
        disabled={appointmentType === ""}
        onClick={() =>
          navigate("/appointments/select-campaign", {
            state: {
              appointmentType,
              selectedPatientId,
              guestInfo,
              apptCampaigns,
              insuranceInfo,
            },
          })
        }
      >
        {strings.next}
      </Button>
    </div>
  );
}
